import { StrikeZoneLocation } from 'interfaces/session/IStrikeZoneDefinition';
import { PlaneAdjustmentKind } from 'interfaces/session/IStrikeZonePlaneConfiguration';
import React from 'react';
import Switch from 'react-switch';
import { DualUnitInput } from './DualUnitInput';
import { AdjustmentToggle, AdjustmentWrapper } from './StrikeZoneCalculationStyles';

interface IProps {
  locationType: StrikeZoneLocation;
  kind: PlaneAdjustmentKind;
  toggleLabel: string;
  inputLabel: string;
  isEnabled: boolean;
  valueInInches: number;
  onToggle: (locationType: StrikeZoneLocation, kind: PlaneAdjustmentKind, isEnabled: boolean) => void;
  onValueChange: (locationType: StrikeZoneLocation, kind: PlaneAdjustmentKind, valueInInches: number) => void;
  testIdPrefix: string;
}

export const PlaneAdjustment: React.FC<IProps> = (props) => {
  const { locationType, kind, toggleLabel, inputLabel, isEnabled, valueInInches, onToggle, onValueChange, testIdPrefix } = props;

  return (
    <AdjustmentWrapper>
      <AdjustmentToggle>
        <Switch
          checked={isEnabled}
          onChange={(checked: boolean) => onToggle(locationType, kind, checked)}
          onColor='#ec691a'
          checkedIcon={false}
          uncheckedIcon={false}
          width={36}
          height={20}
          data-testid={`${testIdPrefix}-toggle`}
        />
        <span>{toggleLabel}</span>
      </AdjustmentToggle>
      {isEnabled && (
        <DualUnitInput
          label={inputLabel}
          valueInInches={valueInInches}
          onChange={(value) => onValueChange(locationType, kind, value)}
          testIdPrefix={testIdPrefix}
        />
      )}
    </AdjustmentWrapper>
  );
};
